import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {Customer} from "../customers/types.ts";

export type SubscriptionDimension = { name: string, value: string }

export enum SubscriptionStatus {
    Active = 'Active',
    Inactive = 'Inactive'
}

export type Subscription = {
    id: string,
    customerId: string,
    customer?: Customer,
    items: { productId?: string, priceId: string, quantity: number }[],
    status: SubscriptionStatus
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}


export interface ISubscriptionTableColumn extends ITableColumn {
    render?: (item: Subscription) => ReactNode;
}
